<mat-form-field appearance="outline" [floatLabel]="floatLabel">
    <mat-label>
        <ng-content select="aum-form-field-label"></ng-content>
    </mat-label>

    <input
        #input
        matInput
        [placeholder]="placeholder"
        autocomplete="nothing"
        [formControl]="aumFormControl"
        (keydown.enter)="_onSearch()"
    />
    <mat-icon
        matSuffix
        *ngIf="aumFormControl!=null && aumFormControl.invalid && aumFormControl.touched"
        class="triangle-warning"
        svgIcon="aumico-pattern-icon-alert-triangle"
    ></mat-icon>
    <mat-icon class="search-icon" matSuffix (click)="_onSearch()" svgIcon="aumico-pattern-icon-search"></mat-icon>
    <mat-error *ngIf="aumFormControl && aumFormControl.invalid">
        <ng-content select="aum-form-error"></ng-content>
    </mat-error>
</mat-form-field>
